import { render, staticRenderFns } from "./manage-content.vue?vue&type=template&id=119abbca&scoped=true&"
import script from "./manage-content.vue?vue&type=script&lang=js&"
export * from "./manage-content.vue?vue&type=script&lang=js&"
import style0 from "./manage-content.vue?vue&type=style&index=0&id=119abbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119abbca",
  null
  
)

export default component.exports